var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8332 4.99992H4.1665C3.70627 4.99992 3.33317 5.37301 3.33317 5.83325V15.8333C3.33317 16.2935 3.70627 16.6666 4.1665 16.6666H15.8332C16.2934 16.6666 16.6665 16.2935 16.6665 15.8333V5.83325C16.6665 5.37301 16.2934 4.99992 15.8332 4.99992ZM4.1665 3.33325C2.78579 3.33325 1.6665 4.45254 1.6665 5.83325V15.8333C1.6665 17.214 2.78579 18.3333 4.1665 18.3333H15.8332C17.2139 18.3333 18.3332 17.214 18.3332 15.8333V5.83325C18.3332 4.45254 17.2139 3.33325 15.8332 3.33325H4.1665Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33333 10C7.8731 10 7.5 10.3731 7.5 10.8333C7.5 11.2936 7.8731 11.6667 8.33333 11.6667H14.1667C14.6269 11.6667 15 11.2936 15 10.8333C15 10.3731 14.6269 10 14.1667 10H8.33333ZM5.83333 13.3333C5.3731 13.3333 5 13.7064 5 14.1667C5 14.6269 5.3731 15 5.83333 15H10.8333C11.2936 15 11.6667 14.6269 11.6667 14.1667C11.6667 13.7064 11.2936 13.3333 10.8333 13.3333H5.83333Z",
    fill: "#777E91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83333 1.66675C5.3731 1.66675 5 2.03984 5 2.50008V5.83341C5 6.29365 5.3731 6.66675 5.83333 6.66675C6.29357 6.66675 6.66667 6.29365 6.66667 5.83341V2.50008C6.66667 2.03984 6.29357 1.66675 5.83333 1.66675ZM14.1667 1.66675C13.7064 1.66675 13.3333 2.03984 13.3333 2.50008V5.83341C13.3333 6.29365 13.7064 6.66675 14.1667 6.66675C14.6269 6.66675 15 6.29365 15 5.83341V2.50008C15 2.03984 14.6269 1.66675 14.1667 1.66675Z",
    fill: "#777E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/CalendarIcon.8559caadf45773a85ebf5126362b7800.svg";
export { ForwardRef as ReactComponent };